module.exports = __webpack_public_path__ + "static/media/logo-128.92ec1aa962bc0e33fa7fd05c96625b29.png";